<script setup>

const sections = defineModel('sections');

function addSection() {

    sections.value.push({
        items: [
            {
                type: 'TEXT',
                content: '<p>Nowa sekcja</p>'
            }
        ]
    });
}
function addSectionAt(sectionIndex) {

    sections.value.splice(sectionIndex, 0, {
        items: [
            {
                type: 'TEXT',
                content: '<p>Nowa sekcja</p>'
            }
        ]
    });
}

function removeSection(sectionIndex) {

    sections.value.splice(sectionIndex, 1);
}

function addText(sectionIndex) {

    sections.value[sectionIndex].items.push({
        type: 'TEXT',
        content: '<p>Nowy tekst...</p>'
    });
}

function addImage(sectionIndex) {

    sections.value[sectionIndex].items.push({
        type: 'IMAGE',
        url: ''
    });
}

function removeItem(sectionIndex, itemIndex) {

    sections.value[sectionIndex].items.splice(
        itemIndex,
        1
    );
}

function moveUp(index) {

    if(index===0)
        return;

    [sections.value[index-1],sections.value[index]] = [sections.value[index],sections.value[index-1]];
}

function moveDown(index){

    if(index===sections.value.length-1)
        return;

    [sections.value[index+1],sections.value[index]] = [sections.value[index],sections.value[index+1]];
}

</script>

<template>
    
    <template  v-for="(section, sectionIndex) in sections"
        :key="'section-' + sectionIndex"
    >
        <div class="d-flex justify-content-end  mb-2 ">
            <button
                class="btn btn-info btn-sm "
                @click="addSectionAt(sectionIndex)"
            >
                + Dodaj sekcję
            </button>
        </div>
        <div
            class="card mb-4"
        >
            <div class="card-header d-flex justify-content-between">
                
                <strong>
                    Sekcja {{ sectionIndex + 1 }}
                </strong>
                <div>
                <button
                    class="btn btn-sm btn-light"
                    @click="moveUp(sectionIndex)"
                >
                ▲
                </button>

                <button
                    class="btn btn-sm btn-light"
                    @click="moveDown(sectionIndex)"
                >
                ▼
                </button>
                </div>
                <button
                    class="btn btn-danger btn-sm"
                    @click="removeSection(sectionIndex)"
                >
                    Usuń sekcję
                </button>

            </div>

            <div class="card-body">

                <div
                    class="row"
                >

                    <div
                        v-for="(item, itemIndex) in section.items"
                        :key="'item-' + sectionIndex + '-' + itemIndex"
                        :class="section.items.length === 1 ? 'col-12' : 'col-md-6'"
                    >

                        <div class="border rounded p-3 mb-3">

                            <div class="d-flex justify-content-end mb-2">

                                <button
                                    class="btn btn-outline-danger btn-sm"
                                    @click="removeItem(sectionIndex, itemIndex)"
                                >
                                    Usuń
                                </button>

                            </div>

                            <!-- TEXT -->

                            <template
                                v-if="item.type === 'TEXT'"
                            >

                                <label>
                                    Treść HTML
                                </label>

                                <textarea
                                    v-model="item.content"
                                    rows="10"
                                    class="form-control"
                                />

                            </template>

                            <!-- IMAGE -->

                            <template
                                v-if="item.type === 'IMAGE'"
                            >

                                <label>
                                    URL zdjęcia
                                </label>

                                <input
                                    v-model="item.url"
                                    class="form-control"
                                />
                                
                                <img
                                    v-if="item.url"
                                    :src="item.url"
                                    class="img-fluid mt-3 border rounded  allegro-image"
                                />

                            </template>

                        </div>

                    </div>

                </div>

                <div class="d-flex gap-2">

                    <button
                        class="btn btn-primary"
                        @click="addText(sectionIndex)"
                        :disabled="section.items.length >= 2"
                    >
                        + Tekst
                    </button>

                    <button
                        class="btn btn-success"
                        @click="addImage(sectionIndex)"
                        :disabled="section.items.length >= 2"
                    >
                        + Zdjęcie
                    </button>

                </div>

            </div>
            
        </div>
    </template>

    

    <button
        class="btn btn-dark"
        @click="addSection"
    >
        + Dodaj sekcję
    </button>

</template>